export const PAGE_TITLE = 'Skinconcerns';
export const PAGE_SINGLE_TITLE = 'Skinconcern';
export const LINK_URL = 'skinconcerns';
export const inputFields = {
  name: {
    type: 'string',
    required: true,
    title: 'Name',
    slug: true,
  },
  icon: {
    type: 'file',
    required: false,
    title: 'Icon',
  },
  image: {
    type: 'file',
    required: false,
    title: 'Image',
  },
  banner_image: {
    type: 'file',
    required: false,
    title: 'Banner Image',
  },
  service_link: {
    type: 'string',
    required: false,
    title: 'Service link',
  },
  description: {
    type: 'html',
    required: false,
    title: 'Description',
  },
  slug: {
    type: 'slug',
    required: false,
    title: 'Slug',
  },
  faqs: {
    type: 'array',
    title: 'Faqs',
    fields: {
      question: {
        type: 'string',
        title: 'Question',
      },
      answer: {
        type: 'text',
        title: 'Question',
      },
    },
  },
  meta_title: {
    type: 'string',
    required: false,
    title: 'Meta Title',
  },
  meta_keyword: {
    type: 'string',
    required: false,
    title: 'Meta Keyword',
  },
  meta_description: {
    type: 'string',
    required: false,
    title: 'Meta Description',
  },
};
export const initialValues = {
  name: '',
  slug: '',
};

export const view_all_table = [
  { name: 'Name', value: 'name' },
  // { name: "Serial No.", value: "serial_no" },
  { name: 'Image', value: 'image', image: true },
  { name: 'Icon', value: 'icon', image: true },
];

export const SIDEBAR_OPTIONS = [
  {
    id: 'name',
    field: 'name',
    label: 'Name',
    type: 'string',
    search_type: 'search',
    inputType: 'text',
    condition: '',
  },
];
